<template>
	<div>
		<van-action-sheet v-model="comShowSpec" :round="false"  @close = "closeSpecModel()">
		  <div class="spec-goods-detail-div">
			  <van-row>
			  	  <van-col span="6">
			  		  <img class="spec-goods-image" :src="comGoodsSpec.thumb"/>
			  	  </van-col>
			  	  <van-col span="12">
			  		  <div class="spec-goods-name">{{comGoodsSpec.name}}</div>
			  		  <div class="spec-goods-specification">{{getSelectedSpec()}}</div>
			  	  </van-col>
				  <van-col span="6">
					  <div class="spec-goods-price">
						  <span>¥</span>
						  <span>{{getSelectedPrice()}}</span>
						  <span class = "spec-goods-old-price">¥{{getSelectedOfficialPrice()}}</span>
					  </div>
				  </van-col>
			  	</van-row>
		    </div>
			
			<div class="spac-list-div">
				<div v-for="(spec_type_item,spec_type_index) in comGoodsSpec.specItemDTOS" :key = "spec_type_index">
					<div class="spec-type-name">
						{{spec_type_item.specName}}
					</div>
					<div class="spec-list-div">
						<van-row>
						    <van-col span="8" v-for="(spec_item,spec_index) in spec_type_item.itemDTOS" :key="spec_index">
								<div class="spec-div" :class="{'spec-click':spec_item.checked == 1,'spec-div-second-line':spec_index>2}" @click="changeSpec(spec_type_index,spec_index)">
									<img v-if="!spec_type_item.specName || spec_type_item.specName == '杯型'" class="spec-image" :src="getSizeImage(spec_item.itemName)"/>
									<span>{{spec_item.itemName}}</span>
								</div>
						    </van-col>
					    </van-row>
					</div>
				</div>
			</div>
			
			<div class = "select-count-div">
				<van-row type="flex" justify="space-between">
				    <van-col span="10">
						<div class="select-count">
						    <van-stepper min="1" max="300" v-model="count" theme="round" disable-input />
						</div>
				    </van-col>
					<van-col span="10">
						<div class="add-goods">
							<van-button @click="changeGoods" round color="#2e6c43">加入购物车</van-button>
						</div>
					</van-col>
				</van-row>
			</div>
	    </van-action-sheet>
	</div>
</template>

<script>
	import { goodsSpecSelect,addShopCar,editShopCar,clearShopCar} from '@/request/api';
	import {Col, Row,Button,ActionSheet,Stepper} from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'ComSpecModel',
		computed: mapGetters(["getGoodsList","sShop"]),
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row,
		      [Button.name]: Button,
		      [ActionSheet.name]: ActionSheet,
		      [Stepper.name]: Stepper,
		      
		 },
		data(){
			return {
				comShowSpec:false,
				comGoodsSpec:{},
				count:1
			}
		},
		watch:{
			showSpec(newVal,oldVal){
				this.count = 1;
				this.comShowSpec = newVal;
			},
			goodsId(newVal,oldVal){
				this.getSpec(newVal);
			},
			goodsSpec(newVal,oldVal){
				this.comGoodsSpec = newVal;
			},
			
		},
		props:{
			showSpec:{
				Boolean,
				default:false
			},
			goodsSpec:{
				Object,
				default:false
			}
		},
		methods:{
			...mapMutations(['addGoodsList','updateGoodsList']),
			closeSpecModel(){
				this.$emit('closeSpecModel')
			},
			//查询杯型图片
			getSizeImage(size){
				let image=''
				switch(size){
					case '中杯':
					image = require('../../assets/size_1.png');
					break;
					case '大杯':
					image = require('../../assets/size_2.png');
					break;
					case '超大杯':
					image = require('../../assets/size_3.png');
					break;
				}
				return image;
			},
			//查询价格
			getSelectedPrice(){
				let price = this.comGoodsSpec.price
				if(!this.comGoodsSpec.specItemDTOS){
					return price;
				}
				for(let itemSpecType of this.comGoodsSpec.specItemDTOS){
					for(let itemSpec of itemSpecType.itemDTOS){
						if(itemSpec.checked == 1){
							price = price + itemSpec.upPrice;
							break;
						}
					}
				}
				return (price*this.count).toFixed(2);
			},
			
			getSelectedPriceOne(){
				let price = 0;
				for(let itemSpecType of this.comGoodsSpec.specItemDTOS){
					for(let itemSpec of itemSpecType.itemDTOS){
						if(itemSpec.checked == 1){
							price = price + itemSpec.upPrice;
							break;
						}
					}
				}
				return price;
			},
			
			
			//查询官方价格
			getSelectedOfficialPrice(){
				let price = this.comGoodsSpec.officialPrice
				if(!this.comGoodsSpec.specItemDTOS){
					return price;
				}
				for(let itemSpecType of this.comGoodsSpec.specItemDTOS){
					for(let itemSpec of itemSpecType.itemDTOS){
						if(itemSpec.checked == 1){
							price = price + itemSpec.upPrice;
							break;
						}
					}
				}
				return price*this.count;
			},
			getSelectedHcPrice(){
				let price = this.comGoodsSpec.hcPrice
				if(!this.comGoodsSpec.specItemDTOS){
					return price;
				}
				for(let itemSpecType of this.comGoodsSpec.specItemDTOS){
					for(let itemSpec of itemSpecType.itemDTOS){
						if(itemSpec.checked == 1){
							price = price + itemSpec.upPrice;
							break;
						}
					}
				}
				return price*this.count;
			},
			//添加购物车操作
			changeGoods(){
				let specs = [];
				let specification = '';
				for(let specTypeItem of this.comGoodsSpec.specItemDTOS){
					for(let specItem of specTypeItem.itemDTOS){
						if(specItem.checked == 1){
							specs.push({
								specId:specTypeItem.specId,
								itemId:specItem.itemId,
								itemName:specItem.itemName,
								upPrice:specItem.upPrice
							})
							specification = specification + specItem.itemName  + '/'
						}
					}
				}
				
				
				// console.log(this.getSelectedPrice(),this.getSelectedOfficialPrice(),this.getSelectedHcPrice())
				console.log(this.comGoodsSpec)
				let goods = {
					thumb:this.comGoodsSpec.thumb,
					name:this.comGoodsSpec.name,
					goodsId:this.comGoodsSpec.id,
					goodsNum:this.count,
					// price:this.comGoodsSpec.price,
					// medium_cup // 售价
					// medium_cup_original // 原价
					// medium_cup_xty // 供货价
					price:this.comGoodsSpec.price, // 售价
					HcPrice:this.comGoodsSpec.hcPrice, // 供货价
					officialPrice:this.comGoodsSpec.officialPrice, // 原价
					foodPrice:this.comGoodsSpec.price, // 售价
					
					// foodPrice:this.getSelectedPrice(),
					// price:this.getSelectedPrice(),
					// HcPrice:this.getSelectedHcPrice(),
					// // officialPrice:this.comGoodsSpec.officialPrice,
					// officialPrice:this.getSelectedOfficialPrice(),
					// // foodPrice:this.comGoodsSpec.foodPrice,
					specs:specs,
					specification:specification
				}
				
				this.getAddGoodsType(this.getGoodsList,goods);
				
			},
			//axios新增购物车
			addGoods(goods){
				let params = {};
				params.location = this.sShop.lonAndLat;
				params.shopName = this.sShop.shopName;
				params.goodsId = goods.goodsId;
				params.goodsNum = goods.goodsNum;
				params.yuedongShoppingDetailVOS = [];
				if(goods.specs){
					for(let item of goods.specs){
						params.yuedongShoppingDetailVOS.push({
							itemId:item.itemId,
							itemName:item.itemName,
							specId:item.specId
						})
					}
				}
				addShopCar(params).then(res => {
					goods.id = res;
					this.addGoodsList(goods);
				});
			},
			//axios更新购物车数量
			updateGoods(goods){
				let data = {
					goodsNum : goods.goodsNum,
					id : goods.id
				}
				editShopCar(data).then(res => {
					this.updateGoodsList(goods);
				}) 
			},
			//判断购物车更新、新增
			getAddGoodsType(goodsList,goods){
				let insertGoods = '';
				let type = ''
				//没有就插入
				// console.log(goodsList,goods)
				// return;
			  if(!goodsList){
				  insertGoods = goods;
				  type =  'post';
			  }else{
				  A:for(let itemGoods of goodsList){
					  if(itemGoods.goodsId == goods.goodsId){
						  //商品ID相同
						  if(itemGoods.specs && goods.specs){
							  let goodsSpecs = goods.specs;
							  //所有规格比较
							  B:for(let itemSpec of itemGoods.specs){
								  for(let goodsSpec of goodsSpecs){
										if(itemSpec.specId == goodsSpec.specId)	{
											if(itemSpec.itemName == goodsSpec.itemName){
												continue B;
											}else{
												continue A;
											}
										}			  
								  }
							  }
							  //更新
							  let count = itemGoods.goodsNum + goods.goodsNum;
							  insertGoods = {
								  id:itemGoods.id,
								  goodsId:itemGoods.goodsId,
								  goodsNum:count
							  };
							  type =  'put'
						  }else if(!itemGoods.specs && !goods.specs){
							  //更新
							  let count = itemGoods.goodsNum + goods.goodsNum;
							  insertGoods = {
								  id:itemGoods.id,
								  goodsId:itemGoods.goodsId,
								  goodsNum:count
							  };
							  type =  'put'
						  }
					  }
				  }
				  //新增
				  if(!insertGoods && !type){
					  insertGoods = goods;
					  type =  'post';
				  }
				  
			  }
			  switch(type){
				  case 'post':
				  let id = this.addGoods(insertGoods);
				  break;
				  case 'put':
				  this.updateGoods(insertGoods)
				  break;
			  }
			  this.comShowSpec = false;
			  
			  
			},
			
			//已选中规格描述
			getSelectedSpec(){
				let selectedSpec = '';
				let specItemDTOS = this.comGoodsSpec.specItemDTOS;
				if(!specItemDTOS){
					return
				}
				for(let i=0 ;i<specItemDTOS.length;i++){
					let itemDTOS = specItemDTOS[i].itemDTOS
					if(i!==0){
						selectedSpec = selectedSpec+"/"
					}
					for(let j=0; j<itemDTOS.length;j++){
						if(itemDTOS[j].checked === 1){
							let itemName = itemDTOS[j].itemName
							selectedSpec = selectedSpec+itemName
						}
					}
				}
				return selectedSpec;
			},
			/**
			 * 点击切换
			 * @param {Object} specTypeIndex
			 * @param {Object} specIndex
			 */
			changeSpec(specTypeIndex,specIndex){
				for(let item of this.comGoodsSpec.specItemDTOS[specTypeIndex].itemDTOS){
					item.checked = 0;
				}
				
				this.comGoodsSpec.specItemDTOS[specTypeIndex].itemDTOS[specIndex].checked = 1;
			}
		}
	}
</script>

<style scoped>
	
	.spec-goods-detail-div {
		padding: 10px;
		background-color: #ffffff;
	}
	
	.spec-goods-image {
		width: 80px;
		height: 80px;
		display: block;
		margin: 0 auto;
	}
	
	.spec-goods-name {
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		padding-top: 10px;
		color: #343434;
		font-size: 17px;
	}
	.spec-goods-specification {
		padding-top: 10px;
		color: #656565;
		font: 15px;
	}
	
	.spec-goods-price {
		padding-top: 40px;
		text-align: right;
	}
	
	.spec-goods-price>span:nth-child(1) {
		color: #c8544a;
		font-size: 16px;
		font-weight: 570;
	}
	.spec-goods-price>span:nth-child(2) {
		padding-right: 5px;
		color: #c8544a;
		font-size: 18px;
		font-weight: 570;
	}
	.spec-goods-price>span:nth-child(3){
		text-decoration: line-through;
		font-size: 13px;
		color: #9b9b9b;
	}
	
	.spac-list-div {
		border-top-style: dashed;
		border-top-color: #e7e7e7;
		width: 100%;
		max-height: 300px;
		overflow-y:auto;
		background-color: #ffffff;
		padding: 10px 16px;
	}
	
	.spec-type-name {
		padding: 10px;
		color: #000000;
		font-size: 14px;
		font-weight: 650;
	}
	
	.spec-div {
		padding: 10px 18px;
		color: #666666;
		text-align: center;
		font-size: 14px;
	}
	
	.spec-div-second-line {
	    margin-top: 10px;
	}
	
	.spec-click {
		background-color: #f6f6f6 !important;
		border-radius: 5px !important;
		color: #000000 !important;
	}
	
	.spec-image {
		width: 55px;
		height: 55px;
		display: block;
		margin: 0 auto;
		margin-bottom: 5px;
		
	}
	
	.select-count-div {
		padding: 10px;
		border-top: solid 1px #eeeeee;
	}
	.select-count {
		margin-left: 15px;
	}
	
	.select-count button:first-child {
		width: 22px;
		height: 22px;
		color: #2e6c43;
		border-color: #2e6c43;
	}
	.select-count button:last-child {
		width: 22px;
		height: 22px;
		background-color: #2e6c43;
		border-color: #2e6c43;
	}
	
	.add-goods {
		height: 33px;
		text-align: right;
	}
	
	.add-goods .van-button{
		font-size: 13px;
		height: 27px;
		padding: 6px;
		margin:0 15px 0 0;
	}
</style>
